import React from "react";
import { products } from "../data";
import { Link } from "react-router-dom";
import { message } from "antd";

function Products() {
  // const dispatch = useDispatch();
  const addProductToCart = (product) => {
    // dispatch(addToCart(product));
    if (sessionStorage.getItem("cartItems") == null) {
      product.qty = 1;
      sessionStorage.setItem("cartItems", JSON.stringify([product]));
    } else {
      const cartItems = JSON.parse(sessionStorage.getItem("cartItems"));
      const check = cartItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        product.qty = 1;
        sessionStorage.setItem("cartItems", JSON.stringify([...cartItems, product]));
      }
    }
    message.success("Product Successfully added to Cart", [1]);
  };

  const addToWishList = (product) => {
    if (sessionStorage.getItem("wishlistItems") == null) {
      sessionStorage.setItem("wishlistItems", JSON.stringify([product]));
    } else {
      const wishlistItems = JSON.parse(sessionStorage.getItem("wishlistItems"));
      const check = wishlistItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        sessionStorage.setItem("wishlistItems", JSON.stringify([...wishlistItems, product]));
      }
    }
    message.success("Product Successfully added to Wishlist", [1]);
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="container mb-2">
        <h3 className="ml-3 mt-3 mb-2" style={{ textTransform: "uppercase " }}>
          Products
        </h3>
        <div className="row">
          {products.map((product, i) => {
            if (i < 4) {
              return (
                <div className="col-lg-3 col-md-6 col-sm-6 mb-5" key={product.productId}>
                  <div className="product-wrapper  text-center">
                    <div className="product-img">
                      <img src={product.url} className="productimage" alt="" />
                      <span className="text-center">
                        <i class="fas fa-dollar-sign" />
                        {product.price}
                      </span>
                      <div className="product-action">
                        <div className="product-action-style">
                          <Link className="wishlist" onClick={() => addToWishList(product)}>
                            <i className="fa fa-heart wishlish" />
                          </Link>
                          <Link className="cart" onClick={() => addProductToCart(product)}>
                            <i className="fa fa-shopping-cart " />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <Link to={`/productdescription/${product.productId}`}>
                      <h5 className="mt-2">{product.productName}</h5>
                    </Link>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
      <Link to="/products" style={{ padding: "10px 20px" }} className="btn-primary btn mb-2 " id="showmorebtn" style={{ textDecoration: "none" }}>
        Show More
      </Link>
    </div>
  );
}
export default Products;
